module.exports = __webpack_public_path__ + "static/img/22_推撥通知.5528119.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/button/22_推撥通知.png
// module id = U3x8
// module chunks = 1